<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select
        ref="dataSourceSelect"
        popper-class="data-source-select-tree"
        class="w-full"
        size="small"
        v-model="form.dataSource"
        placeholder="请选择栏目"
        @visible-change="visibleSelectChange"
        v-if="form.component === 'AppList'"
      >
        <el-option
          :label="columnName"
          :value="form.dataSource"
          :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
        >
          <el-tree
            :props="{
              label: 'name',
              children: 'child',
            }"
            class="text-white max-h-274px overflow-x-hidden data-source-tree"
            ref="treeRef"
            node-key="id"
            highlight-current
            :data="filterColumnData"
            @node-click="treeNodeClick"
            :expand-on-click-node="false"
            :default-expanded-keys="defaultExpandedKeys"
          ></el-tree>
        </el-option>
      </el-select>
      <el-select
        v-model="form.dataSource"
        placeholder="请选择栏目"
        filterable
        @change="sourceChange"
        v-else
      >
        <el-option
          v-for="item in filterColumnData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="列表样式">
      <el-select v-model="form.component" placeholder="请选择" @change="componentChange">
        <el-option
          v-for="item in listType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="显示栏目名称">
      <el-checkbox v-model="form.showTitle" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示摘要" v-if="form.component === 'AppList'">
      <el-checkbox v-model="form.showContent" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示时间">
      <el-checkbox v-model="form.showDate" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示更多">
      <el-checkbox v-model="form.showMore" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示名称" v-if="form.showTitle">
      <el-input
        v-model="form.title"
        placeholder="显示名称"
        @input="selectChange"
        maxlength="20"
        clearable
      />
    </el-form-item>
    <el-form-item label="标题行数" v-if="form.component === 'AppList'">
      <el-select v-model="form.row" @change="selectChange">
        <el-option v-for="item in 3" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>

    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import layoutConfig from './LayoutConfig'
import { informationPublishMap } from '../../js/config'

const columnTypes = informationPublishMap.column
const columnImgTextType = columnTypes.columnImgText // 图文栏目
const columnVideoType = columnTypes.columnVideo // 视频栏目

const listType = [
  {
    name: '文字',
    value: 'AppList',
  },
  {
    name: '图片',
    value: 'H5VerticalNewsImageList',
  },
  {
    name: '视频',
    value: 'H5VerticalNewsVideoList',
  },
]

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      form: {
        dataSource: '', // 数据来源
        showContent: true, // 显示摘要
        showDate: true, // 显示时间
        showPagination: true, // 显示分页
        showTitle: true, // 显示栏目名称
        showMore: true,
        showSign: false, // 显示符号
        row: 1, // 展示行数
        col: 1, // 每行展示条数
        title: '', // 显示名称
        component: listType[0].value,
      },
      columnName: '',
      listType,
      config: {
        w: 10,
        h: 10,
        isAdaptive: true,
      },
      columnData: [],
      defaultExpandedKeys: [],
      columnFlattenData: [],
      filterColumnData: [],
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.form = this.$options.data().form
        if (!_.isEmpty(val)) {
          this.columnName = ''
          _.assign(this.form, val)
          if (val.dataSource) {
            this.columnName = _.find(this.columnFlattenData, { id: val.dataSource })?.name
          }
        } else {
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'component', 'x', 'y', 'i'])
          this.config.isAdaptive = true
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        this.columnData = res
        this.columnFlattenData = treeToOneArray(res, 'child')
        if (this.form.dataSource) {
          this.columnName = _.find(this.columnFlattenData, { id: this.form.dataSource })?.name
        }
        this.getSourceData()
      }
    },
    getSourceData() {
      if (this.form.component === 'H5VerticalNewsImageList') {
        this.filterColumnData = _.filter(this.columnFlattenData, (item) => {
          return item.type === columnImgTextType
        })
      } else if (this.form.component === 'H5VerticalNewsVideoList') {
        this.filterColumnData = _.filter(this.columnFlattenData, (item) => {
          return item.type === columnVideoType
        })
      } else {
        this.filterColumnData = _.cloneDeep(this.columnData)
      }
    },
    sourceChange() {
      this.form.title = _.find(this.columnData, { id: this.form.dataSource })?.name || ''
      this.selectChange()
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    componentChange() {
      this.form.dataSource = ''
      this.form.title = ''
      this.columnName
      this.getSourceData()
      this.selectChange()
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
    visibleSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.treeRef.setCurrentKey(this.form.dataSource) // 设置选中元素
          this.defaultExpandedKeys = [this.form.dataSource]
        } else {
          const nodeDatas = this.$refs.treeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(node) {
      this.form.dataSource = node.id
      this.columnName = node.name
      this.form.title = node.name
      this.$refs.dataSourceSelect.blur()
      this.selectChange()
    },
  },
  created() {
    this.getColumnData()
    this.selectChange()
  },
}
</script>

<style lang="scss">
.data-source-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
  .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss" scoped>
.data-source-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
}
</style>
